import { io } from 'socket.io-client';
import Session from 'supertokens-web-js/recipe/session';
const url = import.meta.env.VITE_API_SOCKET_ENDPOINT;

export const socket = io(url, {
  autoConnect: false,
  transports: ['websocket'],
});

socket.on('connect_error', async (error) => {
  console.log(error, 'DDD');

  // If Unauthorized try again with refreshed token
  if (error.message === 'Unauthorized') {
    await connectToSocket();
  }
});

export async function connectToSocket() {
  const token = await Session.getAccessToken();
  // No session to authenticate with. Callers do not catch, so resolve instead of
  // throwing; SuperTokens sends the user to login on their next API call.
  if (token === undefined) {
    return;
  }
  socket.auth = { Bearer: token };

  console.log('connected to socket');
  socket.connect();
}
